import type { IconProps } from '../types';

export function MessagesIcon({ className, title }: IconProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <g transform="translate(0,-952.36218)">
        <path
          d="m 31.124981,965.34928 c -4.928492,0 -9.031288,3.97991 -9.031288,8.90624 l 0,4.4375 -7.062411,0 c -4.928492,0 -9.0312885,4.00511 -9.0312885,8.96875
      l 0,26.81253 c 0,4.9637 4.1027965,8.9687 9.0312885,8.9687 l 0.468708,0 0,13.9063 a 2.0001998,2.0001998 0 0 0 3.531294,1.3125 l 13.187409,-15.2188 36.656291,0 c 4.928493,0 9.031322,-4.0235 9.031322,-8.9687
      l 0,-4.4375 7.062378,0 c 4.928492,0
      9.031322,-3.9987 9.031322,-8.9062 l 0,-26.87508
      c 0,-4.90755 -4.10283,-8.90624 -9.031322,-8.90624 l -53.843703,0 z m 0,4 53.843703,0 c 2.771112,0 5.031322,2.21198 5.031322,4.90624
      l 0,26.87508 c 0,2.6941 -2.26021,4.9062 -5.031322,4.9062 l -7.062378,0 0,-18.37503 c 0,-4.94515 -4.102829,-8.96875
      -9.031322,-8.96875
      l -42.781287,0 0,-4.4375 c 0,-2.67551 2.260205,-4.90624 5.031284,-4.90624 z M 24.6875,996.13052 c 3.046784,0 5.562497,2.47953 5.562497,5.50008 0,3.0205 -2.515606,5.5 -5.562497,5.5 -3.046925,0 -5.624999,-2.4451 -5.624999,-5.5 0,-3.05495
      2.578074,-5.50008 5.624999,-5.50008 z m 16.749992,0 c 3.070417,0 5.625,2.47953 5.625,5.50008 0,3.0205 -2.554512,5.5 -5.625,5.5
      -3.04689,0 -5.562496,-2.4795 -5.562496,-5.5 0,-3.02055 2.515606,-5.50008 5.562496,-5.50008 z m 16.749992,0 c 3.043418,0 5.593819,2.45013
      5.593819,5.50008 0,3.0499 -2.550402,5.5 -5.593819,5.5 -3.043381,0 -5.593783,-2.4501 -5.593783,-5.5 0,-3.04995 2.550401,-5.50008 5.593783,-5.50008 z"
          fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
}
